






























import { Component, Prop } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import RewardsProgramCommon from '../RewardsProgramCommon.vue';
import { IBusinessType } from '@/models/business';

@Component({
  components: {
    FilledButton
  }
})
export default class Introduction extends RewardsProgramCommon {
  @Prop() flowType!: IBusinessType;
  @Prop() showChooseOperation!: boolean;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get description() {
    if (this.flowType === IBusinessType.BOTH)
      return "Each member's linked credit and debit cards can now be their rewards cards. They could also automatically earn rewards with purchases on your website.";

    if (this.flowType === IBusinessType.ONLINE)
      return 'Every time a member makes a purchase on your website, they will automatically be rewarded with coins.';

    return "Every member's linked credit and debit cards will now be their rewards card. If they use their card at your business in-store or in the Twism App, they get rewards.";
  }

  get redirectToSlug() {
    const providersList =
      this.$store.getters['merchant/getProvidersList'] || [];
    const connectedProviders = providersList
      .filter((provider: any) => provider && provider.name !== 'fidel')
      .filter((provider: any) => provider && provider.connected);

    if (!connectedProviders.length) {
      return this.showChooseOperation
        ? this.ERewardsProgramStepSlug.OPERATION
        : this.ERewardsProgramStepSlug.OPERATION_POS_SYSTEM;
    }

    return this.ERewardsProgramStepSlug.REWARD_RATIO;
  }

  get currencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }
}
